function openZendeskChat(event) {
    event.preventDefault(); 
    if (typeof zE === 'function') {
      //zE('messenger', 'open');
      zE('webWidget', 'open');
    } else {
      console.log('Zendesk widget not loaded yet.');
    }
  }


  /* sidebar menu */
document.addEventListener("DOMContentLoaded", function () {

  const allMenus = document.querySelectorAll('.sub-menu');
  const firstMenu = document.querySelector('.main-menu > li:first-child .sub-menu');
  if (firstMenu) {
    firstMenu.classList.add('active');
  }
  document.querySelectorAll('.main-menu .svg-wrapper').forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      const parentLi = this.closest('li');
      const subMenu = parentLi.querySelector('.sub-menu');
      allMenus.forEach(menu => {
        if (menu !== subMenu) {
          menu.classList.remove('active');
        }
      });
      if (subMenu) {
        subMenu.classList.toggle('active');
      }
    });
  });

});

// colletion and product page FAQ


document.addEventListener("DOMContentLoaded", function () {

  /* FAQ Split - Desktop Only */
  if (window.innerWidth > 991) {

    const container = document.querySelector("#nav-faq .faq-section-metafield");

    if (container) {

      const items = Array.from(
        container.querySelectorAll(".faq-wrapper .faq-item")
      );

      if (items.length) {

        const splitIndex = Math.ceil(items.length / 2);

        const leftCol = document.createElement("div");
        leftCol.className = "faq-column";

        const rightCol = document.createElement("div");
        rightCol.className = "faq-column";

        items.forEach((item, index) => {
          if (index < splitIndex) {
            leftCol.appendChild(item);
          } else {
            rightCol.appendChild(item);
          }
        });

        const wrapper = container.querySelector(".faq-wrapper");
        if (wrapper) wrapper.remove();

        container.appendChild(leftCol);
        container.appendChild(rightCol);
      }
    }
  }

  /* FAQ Accordion (Desktop + Mobile) */
  document.querySelectorAll(".faq-section-metafield").forEach(section => {

    const faqItems = section.querySelectorAll(".faq-item");

    faqItems.forEach(item => {

      const button = item.querySelector(".faq-question");

      if (!button) return;

      button.addEventListener("click", () => {

        const isOpen = item.classList.contains("active");

        faqItems.forEach(i => i.classList.remove("active"));

        if (!isOpen) {
          item.classList.add("active");
        }

      });

    });

  });

  /* Product Tabs Mobile Accordion */
  document.querySelectorAll(".accordion-title").forEach(button => {

    button.addEventListener("click", function () {

      const item = this.parentElement;

      item.classList.toggle("active");

    });

  });

});

// tab products
  document.addEventListener("DOMContentLoaded", function () {

  const tabButtons = document.querySelectorAll("#nav-tab .nav-link");
  const tabPanes = document.querySelectorAll("#nav-tabContent .tab-pane");
  tabButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      tabButtons.forEach(function (btn) {
        btn.classList.remove("active");
        btn.setAttribute("aria-selected", "false");
      });

      tabPanes.forEach(function (pane) {
        pane.classList.remove("show");
        pane.classList.remove("active");
      });

      this.classList.add("active");
      this.setAttribute("aria-selected", "true");
      const targetSelector = this.getAttribute("data-bs-target");
      const targetPane = document.querySelector(targetSelector);
      if (targetPane) {
        targetPane.classList.add("show");
        targetPane.classList.add("active");

          // Scroll to the active tab content
          const headerHeight = document.querySelector(".header-wrapper")?.offsetHeight || 0;
          const tabsHeight = document.querySelector("#nav-tab")?.offsetHeight || 0;
          window.scrollTo({
            top: targetPane.offsetTop - headerHeight - tabsHeight,
            behavior: "smooth"
          });
      }

    });

  });

});


// megamenus
document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".custom-mega-menu");
  megaMenus.forEach(menu => {
    const triggers = menu.querySelectorAll(".custom-menu-trigger");
    const panels = menu.querySelectorAll(".custom-menu-panel");
    triggers.forEach(trigger => {
      trigger.addEventListener("mouseenter", function () {
        const target = this.getAttribute("data-menu");
        triggers.forEach(btn => {
          btn.classList.remove("active");
        });
        panels.forEach(panel => {
          panel.classList.remove("active");
        });
        this.classList.add("active");
        const activePanel = menu.querySelector("#" + target);
        if(activePanel){
          activePanel.classList.add("active");
        }
      });
    });
  });
});




document.addEventListener('click', function(e){

  if(e.target.closest('.reset__button')){

    const form = e.target.closest('form');
    const input = form.querySelector('.search__input');

    if(input){
      input.value = '';
      input.focus();

      const predictive = document.querySelector('#predictive-search-results');
      if(predictive){
        predictive.innerHTML = '';
      }
    }
  }

});



  document.addEventListener("DOMContentLoaded", function() {
    const observer = new MutationObserver((mutations, obs) => {
      const buyButton = document.querySelector('.shopify-payment-button__button--unbranded');
      if (buyButton) {
        buyButton.textContent = 'Buy Now';
        obs.disconnect(); 
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });



document.addEventListener('DOMContentLoaded', function() {

  const accordions = document.querySelectorAll('.faq-section .accordion');

  accordions.forEach(function(btn) {

    btn.addEventListener('click', function() {

      const panel = this.nextElementSibling;
      const icon = this.querySelector('.icon');

      this.classList.toggle('active');

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        if(icon) icon.textContent = '+';
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        if(icon) icon.textContent = '×';
      }

    });

  });

});



//to play youtube videos one at a time 
var players = [];
function onYouTubeIframeAPIReady() {
  document.querySelectorAll('.youtube-player').forEach(function (iframe) {
    players.push(
      new YT.Player(iframe, {
        events: {
          'onStateChange': onPlayerStateChange
        }
      })
    );

  });

}
function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING) {
    players.forEach(function(player) {
      if (player !== event.target) {
        player.pauseVideo();
      }
    });
  }
}



document.addEventListener('DOMContentLoaded', function() {

  function equalizeCardHeadingHeight() {

    const headings = document.querySelectorAll('.card__heading');

    if (!headings.length) return;

    let maxHeight = 0;

    headings.forEach(function(heading) {
      heading.style.height = 'auto';
      maxHeight = Math.max(maxHeight, heading.offsetHeight);
    });

    headings.forEach(function(heading) {
      heading.style.height = maxHeight + 'px';
    });
  }

  equalizeCardHeadingHeight();

  window.addEventListener('resize', equalizeCardHeadingHeight);

});



// child link menu click
document.querySelectorAll('.mobile-parent-link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.stopPropagation();

    const details = this.closest('details');

    if (details && !details.open) {
      window.location.href = details.dataset.url;
    }
  });
});

//form -email validation
document.querySelectorAll('#ContactForm, .appointment-form').forEach(form => {
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const emailInput = form.querySelector('input[type="email"]');
    const submitBtn = form.querySelector('button[type="submit"]');

    if (!emailInput) return;
    const emailPattern =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

    const emailValue = emailInput.value.trim();
    if (!emailPattern.test(emailValue)) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
      }
      emailInput.setCustomValidity('Enter a valid email');
      emailInput.reportValidity();
      emailInput.focus();
      emailInput.addEventListener('input', function handler() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
        emailInput.setCustomValidity('');
        emailInput.removeEventListener('input', handler);
      });
      return;
    }
    emailInput.setCustomValidity('');
    const currentPath = window.location.pathname;
let successUrl = '/pages/thankyou-contact-us'; // Default for all forms

if (currentPath === '/pages/get-a-quote') {
  successUrl = '/pages/thank-you-get-a-quote';
} else if (currentPath === '/pages/rfq') {
  successUrl = '/pages/thank-you-quote-enquiry';
}

fetch(form.action, {
  method: 'POST',
  body: new FormData(form)
})
.then(() => {
  window.location.href = successUrl;
})
.catch((error) => {
  console.error(error);
  alert('There was a problem submitting the form. Please try again.');
});

  }, true);

});

//script country name to appear in email after form submission
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form.free-consultation');

  if (!form) return;

  form.addEventListener('submit', function () {
    const country = document.getElementById('consut-contactCountry');
    const message = document.getElementById('consut-contactMessage');

    if (country && message) {
      message.value = 'Country: ' + country.value + '\n\n' + message.value;
    }
  });
});



/* Quantity box - prevent input like -1 or +1 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('input', () => {
      if (input.value < 1) input.value = 1;
    });

    input.addEventListener('keydown', e => {
      if (['-', '+', 'e'].includes(e.key)) e.preventDefault();
    });
  });
});